import type { StorageKey } from "../types/StorageKey";
import { InMemoryStorage } from "./in-memory-storage";

const inMemoryStorage = new InMemoryStorage();

const getStorage = (): Storage => {
  return globalThis.localStorage ? globalThis.localStorage : inMemoryStorage;
};

const storage: Storage = getStorage();

export const storageService = {
  getItem(key: StorageKey | string): string | null {
    return storage.getItem(key);
  },
  /**
   * @param key prefer to use StorageKey until you have a reason to use string
   * good reason to use string is when your key is dynamic ie key depends on the user id, for example
   */
  getItemAsObject<T>(key: StorageKey | string): T | null {
    const value = storage.getItem(key);
    if (value) {
      return JSON.parse(value) as T;
    }
    return null;
  },
  save(key: StorageKey | string, value: unknown, stringify = true): void {
    storage.setItem(key, stringify ? JSON.stringify(value) : (value as string));
  },
  removeItem(key: StorageKey | string): void {
    storage.removeItem(key);
  },
  clear(): void {
    storage.clear();
  },
};
